export default {
    image (name, type = '') {
        name = type.length ? type + '/' + name : name
        return require('@/assets/img/' + name)
    }
}